<template>
  <el-dialog
    :title="title"
    :visible.sync="show"
    :center="true"
    width="850px"
    v-loading="loading"
    :before-close="handleClose">
    <div style="padding-right: 20px">
        <el-form
          :model="formValidate"
          :rules="ruleValidate"
          ref="formValidate"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-form-item label="任务名称" prop="reportName">
            <el-input v-model="formValidate.reportName"></el-input>
          </el-form-item>
          <el-form-item label="执行时间" prop="time">
            <el-date-picker
              v-model="formValidate.time"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="重复执行" prop="repet" v-if="type === 'add'">
            <el-col :span="3">
              <el-checkbox v-model="formValidate.repet"></el-checkbox>
            </el-col>
            <template v-if="formValidate.repet">
                <el-col :span="7">
                  <el-form-item prop="repetType">
                    <div class="flex-box">
                      <span>重复周期</span>
                      <el-select v-model="formValidate.repetType" placeholder="请选择" style="width: 100px; marginLeft: 6px">
                        <el-option value="day" label="按天"></el-option>
                        <el-option value="week" label="按周"></el-option>
                        <el-option value="month" label="按月"></el-option>
                        <el-option value="year" label="按年"></el-option>
                      </el-select>
                    </div>
                  </el-form-item>
                </el-col>
              <template v-if="formValidate.repetType">
                <el-col :span="14" class="flex-box">
                  <div class="flex-box jc-end" v-if="formValidate.repetType === 'day'">
                    <el-form-item >
                      <span>每</span>
                      <!-- <el-input v-model="formValidate.repetMethod1" style="width: 100px; margin: 0 6px" ></el-input> -->
                      <span>天</span>
                    </el-form-item>
                  </div>
                  <div class="flex-box jc-end" v-else-if="formValidate.repetType === 'week'">
                    <span>每</span>
                    <span>周的周</span>
                    <el-form-item prop="day">
                      <el-select v-model="formValidate.day" style="width: 60px; margin: 0 6px" placeholder="">
                        <el-option value="2" label="一"></el-option>
                        <el-option value="3" label="二"></el-option>
                        <el-option value="4" label="三"></el-option>
                        <el-option value="5" label="四"></el-option>
                        <el-option value="6" label="五"></el-option>
                        <el-option value="7" label="六"></el-option>
                        <el-option value="1" label="日"></el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                  <div class="flex-box jc-end" v-else-if="formValidate.repetType === 'month'">
                    <span>每</span>
                    <span>月的</span>
                    <el-form-item prop="date">
                      <el-input-number
                        v-model="formValidate.date"
                        controls-position="right"
                        :min="1"
                        :max="31"
                        step-strictly
                        :step="1"
                        style="width: 88px; margin: 0 6px"
                      ></el-input-number>
                    </el-form-item>
                    <span>号</span>
                  </div>
                  <div class="flex-box jc-end" v-else>
                    <span>每</span>
                    <span>年</span>
                    <el-form-item prop="repetTime" v-if="formValidate.repetType === 'year'">
                      <el-select v-model="formValidate.month" style="width: 66px; margin: 0 6px" placeholder="">
                        <el-option :value="item" :label="item" v-for="(item, index) of 12" :key="index"></el-option>
                      </el-select>
                      <span>月</span>
                    </el-form-item>
                    <el-form-item prop="date">
                      <el-input-number
                        v-model="formValidate.date"
                        controls-position="right"
                        :min="1"
                        :max="31"
                        step-strictly
                        :step="1"
                        style="width: 88px; margin: 0 6px"
                      ></el-input-number>
                    </el-form-item>
                    <span>号</span>
                  </div>
                  <el-form-item prop="repetTime">
                    <el-time-picker
                      v-model="formValidate.repetTime"
                      style="width: 116px"
                      value-format="s m H"
                    >
                    </el-time-picker>
                  </el-form-item>
                </el-col>
              </template>
            </template>
          </el-form-item>
          <el-col :span="12">
            <el-form-item label="发起部门" prop="dept">
              <el-input v-model="userData.deptName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="发起人" prop="creater">
              <el-input v-model="userData.userName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-form-item label="人群类型" prop="crowdType" v-if="type === 'add'">
            <el-select v-model="formValidate.crowdType" style="width:100%" @change="typeChange">
              <el-option value="0" label="人员"></el-option>
              <el-option value="1" label="部门"></el-option>
              <el-option value="2" label="全校"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="任务人群" prop="userIds" v-if="type === 'add'&&userShow">
            <el-col :span="20">
              <el-input :value="personViewText" disabled></el-input>
            </el-col>
            <el-col :span="4" style="display: flex;justify-content: flex-end">
              <el-button icon="el-icon-circle-plus-outline" @click="addUser" v-if="!bmShow">添加人员</el-button>
              <el-button icon="el-icon-circle-plus-outline" @click="addBm" v-else>添加部门</el-button>
            </el-col>
          </el-form-item>
          <el-form-item label="选择服务" prop="serveId" v-if="type === 'add'">
            <el-input :value="serverViewText" @focus="selectServer" :disabled="type === 'edit'"></el-input>
          </el-form-item>
          <!-- <el-form-item label="消息提醒" prop="message" v-if="type === 'edit'">
            <el-radio v-model="formValidate.message" label="1">开启</el-radio>
            <el-radio v-model="formValidate.message" label="2">不开启</el-radio>
            <span style="color: red">(提醒消息将于任务开始时进行推送)</span>
          </el-form-item> -->
          
          <el-form-item label="任务创建方式" v-if="bmShow">
            <el-radio-group v-model="formValidate.createMode">
              <el-radio :label="0">统一创建</el-radio>
              <el-radio :label="1">按部门创建</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>

    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submitForm">提交</el-button>
      <el-button @click="handleClose">取消</el-button>
    </span>

    <ChargePerson
      ref="personModal"
      :personData="personData"
      @closePerson="closePerson"
    />
    <ServerSelect
      ref="serverSelect"
      @closeServerSelect="closeServerSelect"
    />
    <DepartmentSelect
    :dialogVisible="bmVisible"
    @visibleClose="visibleClose"
    @submit="submit"
    />
  </el-dialog>
</template>

<script>
import ChargePerson from './chargePerson'
import DepartmentSelect from './departmentSelect'
import ServerSelect from './serverSelect'
import {getDeptById} from '@/api/management/dept'
import {tHallBatchReportSaveOrUpdate} from '@/api/management/report'
import moment from 'moment'

export default {
  name: "addOrEdit",
  components: {
    ChargePerson,
    ServerSelect,
    DepartmentSelect
  },
  props: [],
  data() {
    return {
      loading: false,
      show: false,
      title: '新建任务',
      type: 'add',
      formValidate: {
        reportName: '',
        time: '',
        repet: false,
        repetType: '',
        date: '',
        day: '',
        month: '',
        repetTime: '',
        userIds: [],
        serveId: '',
        cron: '',
        message: '1',
        id: '',
        createMode:0,
        crowdType:'0',
      },
      ruleValidate: {
        reportName: [
          {required: true, message: '填报任务名称不能为空', trigger: 'blur'},
          {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'}
        ],
        time: [
          {required: true, message: '执行时间不能为空', trigger: 'blur'},
        ],
        userIds: [
          {required: true, message: '请选择人员', trigger: 'blur'},
        ],
        serveId: [
          {required: true, message: '请选择服务'},
        ],
        repetType: [
          {required: true, message: '请选择重复周期', trigger: 'blur'},
        ],
        // repetMethod1: [
        //   {required: true, message: '不能为空', trigger: 'blur'},
        // ],
        day: [
          {required: true, message: '不能为空', trigger: 'blur'},
        ],
        date: [
          {required: true, message: '不能为空', trigger: 'blur'},
        ],
        repetTime: [
          {required: true, message: '不能为空', trigger: 'blur'},
        ],
        crowdType: [
          {required: true, message: '请选择人群类型', trigger: 'blur'},
        ],
      },
      personViewText: '',
      serverViewText: '',
      personData: {
        userData: [],
        state: false,
        disabled: false,
        data: []
      },
      userData: {
        userName: '',
        userId: '',
        deptId: '',
        deptName: '',
      },
      bmShow:false,//显示部门选择按钮
      userShow:true,//任务人群显示
      bmVisible:false,//部门选择弹窗
    };
  },
  computed: {},
  created() {},
  mounted() {
  },
  destroyed() {},
  methods: {
    autoUserData(type, data){
      if(type === 'add'){
        const {deptId, userId, userName} = JSON.parse(localStorage.getItem('userData'))
        this.userData.userId = userId;
        this.userData.userName = userName;
        this.userData.deptId = deptId;
        getDeptById(deptId).then(({data}) => {
          this.userData.deptName = data.data.name
        }).catch(() => {
          this.$message.error('获取部门信息失败');
        })
      }else {
        this.userData.userName = data.userName;
        this.userData.deptName = data.deptName;
      }
    },
    dialogShow (type, data) {
      this.show = true;
      this.loading = true;
      this.type = type;
      this.title = type === 'add' ? '新建任务' : '编辑任务';

      if(type === 'edit' && data){
        this.formValidate.reportName = data.reportName;
        this.formValidate.time = [data.beginTime, data.endTime];
        this.formValidate.id = data.id;
        this.$nextTick(() => {
          this.$refs.formValidate.clearValidate()
        })
      }else {
        this.personViewText = '';
        this.serverViewText = '';
        this.$nextTick(() => {
          this.$refs.formValidate.resetFields()
        })
      }
      this.autoUserData(type, data)
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    addUser() {
      this.personData.state = true;
    },
    addBm(){
      this.bmVisible = true;
    },
    selectServer(){
      this.$refs.serverSelect.dialogShow();
    },
    closePerson(obj) {
        console.log(obj,'obj');
        if (!obj.mans) {
        this.personData.state = false;
        return;
      }
      for (let i = 0; i < obj.data.length; i++) {
        if (isNaN(obj.data[i])) {
          obj.data.splice(i, 1);
        }
      }
      if (obj.mans.length > 0) {
        this.personViewText = "";
        obj.mans.forEach((item, index) => {
          if (index != obj.mans.length - 1) {
            this.personViewText += `${item.name},`;
          } else {
            this.personViewText += `${item.name}`;
          }
        });
      } else {
        this.personViewText = "";
      }

      console.log(this.personViewText);


      if (obj.data.length > 0) {
        this.formValidate.userIds = obj.data;
      }
      this.personData.userData = obj.data;
      this.personData.data = obj.mans;
      this.personData.state = false;
      // this.planpermissionUserSubmit();
    },
    submitForm(){
      this.$refs.formValidate.validate((valid) => {
        if(valid){
          let obj = {}
          obj.beginTime =this.formValidate.time[0];
          obj.endTime =this.formValidate.time[1];
          obj.reportName = this.formValidate.reportName;

          if(this.type === 'edit'){
            obj.id = this.formValidate.id
          }else {
            obj.deptId = String(this.userData.deptId);
            obj.chargeMan = String(this.userData.userId);
            this.formValidate.userIds.forEach((item, index) => {
              this.formValidate.userIds[index] = String(item)
            });
            obj.serveId = this.formValidate.serveId;
            obj.crowdType = this.formValidate.crowdType;
            //有部门则传任务创建方式
            if(this.bmShow){
              obj.createMode = this.formValidate.createMode;
              obj.deptIds = this.formValidate.userIds;
            }else{
              obj.userIds = this.formValidate.userIds;
            }

            if(this.formValidate.repet){
              if(this.formValidate.repetType==='day'){
                obj.cron = `${this.formValidate.repetTime} * * ?`
              }else if(this.formValidate.repetType==='week'){
                obj.cron = `${this.formValidate.repetTime} ? * ${this.formValidate.day}`
              }else if(this.formValidate.repetType==='month'){
                obj.cron = `${this.formValidate.repetTime} ${this.formValidate.date} * ?`
              }else if(this.formValidate.repetType==='year'){
                obj.cron = `${this.formValidate.repetTime} ${this.formValidate.date} ${this.formValidate.month} ?`
              }
            }else {
              obj.cron = null;
            }
          }
          tHallBatchReportSaveOrUpdate(obj, this.type).then(({data}) => {
            if(data.code == 0){
              this.$message.success('操作成功')
              this.handleClose()
              this.$emit('onTaskSubmit')
            }
          }).catch(() => {
            this.$message.error('操作失败');
          })
        }
      })
    },
    closeServerSelect(obj){
      this.formValidate.serveId = obj.id;
      this.serverViewText = obj.serveName;
    },
    //人群类型选择
    typeChange(val){
      if(val==1){
        this.bmShow = true;
        this.userShow = true;
      }
      if(val==0){
        this.bmShow = false;
        this.userShow = true;
      }
      if(val==2){
        this.userShow = false;
        this.bmShow = false;
      }
    },
    visibleClose(){
      this.bmVisible = false;
    },
    submit(data){
      if (data.names.length > 0) {
        this.personViewText = "";
        data.names.forEach((item, index) => {
          if (index != data.names.length - 1) {
            this.personViewText += `${item},`;
          } else {
            this.personViewText += `${item}`;
          }
        });
      } else {
        this.personViewText = "";
      }
      //部门id
      if(data.ids.length > 0){
        this.formValidate.userIds = data.ids;
      }else{
        this.formValidate.userIds = [];
      }
      this.bmVisible = false;
    },
    handleClose(){
      this.bmShow = false;
      this.show = false
    }
  },
  watch: {},
  filters: {}
};
</script>

<style scoped>
.jc-end {
  justify-content: flex-end;
  padding-right: 20px;
}
</style>
